import HtmlAttrib from '@/generated/classes/HtmlAttrib';
import { HtmlParam as HtmlParamBase } from '@/generated/classes/HtmlAttrib';
import { HtmlType as HtmlTypeBase } from '@/generated/classes/HtmlAttrib';
export default class HtmlAttribExtend extends HtmlAttrib {
  constructor() {
    super();
  }
}
export class HtmlParam extends HtmlParamBase {
  constructor() {
    super();
  }
}
export class HtmlType extends HtmlTypeBase {
  constructor() {
    super();
  }
}
